import '../App.css';
import React from 'react';
import {  Flex, Provider, defaultTheme, Heading, Content, Unauthorized, IllustratedMessage } from '@adobe/react-spectrum';
import DeviceDesktop from '@spectrum-icons/workflow/DeviceDesktop';
import GlobeStrike from '@spectrum-icons/workflow/GlobeStrike';
import Resize from '@spectrum-icons/workflow/Resize';
import Homepage from '@spectrum-icons/workflow/Homepage';


function ErrorForm({errorType}) {
    return (
        <>          
           <Provider theme={defaultTheme} colorScheme='light'>
                <Flex direction="column" justifyContent={'center'} alignItems={"center"} height={'size-6000'}>             
                <IllustratedMessage>
                    {errorType === "deviceType" ? 
                        <>
                            <DeviceDesktop />
                            <Heading>Error: Invalid device</Heading>
                            <Content>
                                You must be on a desktop or laptop computer to participate in this study. Try again on a desktop or laptop computer.
                            </Content>
                        </>
                    : errorType === "network" ?
                    
                    <>
                        <GlobeStrike />
                        <Heading>Error: No connection</Heading>
                        <Content>
                            You are not connected to the internet. Try again once a connection has been established.
                        </Content>
                    </>

                    : errorType === "windowSize" ?

                    <>
                        <Resize />
                        <Heading>Error: Window size</Heading>
                        <Content>
                            Your browser window is too small. Try resizing the window to be larger.
                        </Content>
                    </>

                    : errorType === "browser" ?
                    
                    <>
                        <Homepage />
                        <Heading>Error: Unsupported browser</Heading>
                        <Content>
                            You are using an unsupported browser. Please use Google Chrome to participate in this experiment.
                        </Content>
                    </>
                    
                    : null} 
                </IllustratedMessage>
                </Flex>
            </Provider>
        </>
    );
}

export default ErrorForm;